import React, { useContext, useState } from 'react';
import { Button } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import MergeTicketsDialog from '@totem/components/ticketing/listContainer/MergeTicketsDialog';
import TicketingContext from '@totem/components/ticketing/listContainer/ticketingContainerContext';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull, isNull } from '@totem/utilities/common';

const MergeTicketsButton = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { selectedTickets } = useContext(TicketingContext);
  const [showDialog, setShowDialog] = useState(false);

  const title =
    isNotNull(selectedTickets) && selectedTickets.length > 0
      ? `Merge (${selectedTickets.length})`
      : 'Merge';

  return (
    <>
      <IBTooltip content={permissions.ticketingAdministrator.tooltip}>
        <Button
          disabled={
            showDialog ||
            !permissions.ticketingAdministrator.hasPermissions(userProfile) ||
            isNull(selectedTickets) ||
            selectedTickets.length === 0
          }
          onClick={() => {
            setShowDialog(true);
          }}
        >
          {title}
        </Button>
      </IBTooltip>
      <MergeTicketsDialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
      />
    </>
  );
};

export default MergeTicketsButton;
